<template>
  <div>
    <div class="text-xs-right">
      <v-dialog v-model="altTextDialog" persistent max-width="600px" v-if="!isNotAltText">
        <template v-slot:activator="{ on }">
          <v-btn small color="primary" dark v-on="on">{{ $t('message_notification') }}</v-btn>
        </template>
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label for>{{ $t('message_notification') }}</label>
                <input
                  placeholder="This is a Menu list"
                  type="text"
                  v-model="dataAltText"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <div class="text-xs-right">
                <v-btn
                  outline
                  @click="
                    altTextDialog = false
                    dataAltText = altText
                  "
                  >{{ $t('close') }}</v-btn
                >
                <v-btn
                  color="primary"
                  @click="
                    altTextDialog = false
                    changeAltText()
                  "
                  >{{ $t('Save') }}</v-btn
                >
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-btn
        v-if="!isNotRatio"
        small
        outline
        color="primary"
        flat
        class="ma-0"
        @click="convertImageRatio"
      >
        <span class="material-icons mr-2">
          {{ ratio == 'square' ? 'crop_16_9' : 'crop_square' }}</span
        >
        {{ $t(`Resize to ${ratio == 'square' ? 'Horizontal' : 'Square'}`) }}
      </v-btn>
    </div>
    <div
      style="overflow-x: auto; overflow-y: hidden; margin-bottom: 5px; margin-top: 15px"
      v-if="generics"
    >
      <div
        style="display: flex; margin: 0; align-items: stretch; padding-bottom: 5px"
        :style="{ width: generics.length * 315 + (generics.length < 10 ? 315 : 0) + 'px' }"
      >
        <div
          style="width: 300px; margin-right: 15px"
          v-for="(generic, index) in generics"
          :key="`generic_${index}_${timestamp}`"
        >
          <generic-manage
            :isNotRatio="isNotRatio"
            :key="`generic_${index}_${timestamp}`"
            :vkey="index"
            v-model="generics[index]"
            @onDelete="onDeleteGeneric(index)"
            :ratio="ratio"
            :isCatalogue="isCatalogue"
          >
            <move-horizontal
              :key="`generic_${index}_${timestamp}`"
              slot="move"
              :index="index"
              :max="generics.length"
              @onMove="onMove(index, $event)"
              style="display: inline-block;"
            ></move-horizontal>
          </generic-manage>
        </div>

        <div
          v-if="generics.length < 10"
          @click="addGeneric"
          style="
          position: relative;

          width: 300px;
          border: 4px dashed #eee;
          border-radius: 20px;
          cursor: pointer;
        "
          :style="{ 'min-height': ratio == 'horizontal' ? '157px' : '300px' }"
        >
          <div
            style="
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -10px;
            margin-top: -23px;
            font-size: 32px;
          "
          >
            <span class="fa fa-plus"></span>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import GenericManage from '@/components/elements/GenericManage'
import MoveHorizontal from '@/components/elements/MoveHorizontal'
import dayjs from 'dayjs'
export default {
  props: {
    value: {
      default: undefined
    },
    isNotRatio: { default: false },
    isNotAltText: { default: false },
    ratio: { default: 'square' },
    altText: { default: '' },
    isCatalogue: {
      default: false,
      type: Boolean
    }
  },
  components: {
    GenericManage,
    MoveHorizontal
  },
  data: function() {
    return {
      generics: undefined,
      altTextDialog: false,
      dataAltText: this.altText,
      timestamp: dayjs().format('x')
    }
  },
  mounted: function() {
    this.generics = this.value
    if (this.isNotRatio) {
      this.ratio = 'horizontal'
    }
  },
  methods: {
    changeAltText() {
      this.$emit('changealtText', this.dataAltText)
    },
    convertImageRatio() {
      this.$emit('changeRatio', this.ratio == 'horizontal' ? 'square' : 'horizontal')
    },
    onDeleteGeneric(index) {
      if (this.generics.length == 1) {
        this.$emit('deleteMessage')
      } else {
        this.generics.splice(index, 1)
      }
    },
    onMove: function(index, direction) {
      var vm = this
      console.log(vm.generics)
      if (direction == 'left') {
        vm.generics = vm.generics.splice(index, 0, vm.generics.splice(index - 1, 1)[0])
      } else if (direction == 'right') {
        vm.generics = vm.generics.splice(index, 0, vm.generics.splice(index + 1, 1)[0])
      }
      vm.timestamp = dayjs().format('x')
    },
    addGeneric: function() {
      this.generics.push({
        image_url: null,
        title: '',
        subtitle: '',
        buttons: []
        // default_action: {
        //   type: 'web_url',
        //   url: '',
        // },
      })
    }
  },
  watch: {
    value: function(newVal) {
      this.generics = newVal
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentGenericManage.vue